import { PANEL_WIDTH } from "containers/RightPanel/RightPanel.styles";
import { PageWrapper } from "layouts/Layout.styles";
import { fadeInLeft, fadeOutRight } from "react-animations";
import styled from "styled-components";
import { HeaderButton } from "styles/parcelsStyles";

export const OutgoingWrapper = styled(PageWrapper)<{
  $isPanelOpened: boolean;
}>`
  position: absolute;
  width: 100%;
  animation: none;
  transition: padding-right 0.2s ease-in-out;

  /* Exactly the panel's width: the rows run up to the panel's edge, so its
     shadow falls across them instead of on a strip of bare ground. */
  ${({ $isPanelOpened }) =>
    $isPanelOpened && `padding-right: ${PANEL_WIDTH};`}

  ${({ theme }) => theme.xs`
    padding-right: 0;
  `}

  &.page-enter {
    animation: ${fadeInLeft} 0.22s ease;
  }

  &.page-exit {
    animation: ${fadeOutRight} 0.22s ease;
  }

  section:last-child {
    margin-bottom: 20px;
  }
`;

export const PayAllHeaderButton = styled(HeaderButton)`
  margin: 0 10px;
`;

export const PaymentHeaderContent = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  white-space: nowrap;
`;
